// import React from 'react';
// import {
//   Card,
//   CardHeader,
//   CardContent,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   Button,
//   Collapse,
// } from '@mui/material';

// const LeadFilters = ({
//   showFilters,
//   filters,
//   sort,
//   noActivity,
//   statusOptions,
//   usersList,
//   onFilterChange,
//   onSortChange,
//   onNoActivityChange,
//   onClearFilters,
// }) => {
//   return (
//     <Collapse in={showFilters}>
//       <Card sx={{ mb: 3 }}>
//         <CardHeader
//           title="Filters & Sorting"
//           action={
//             <Button onClick={onClearFilters} color="primary">
//               Clear All
//             </Button>
//           }
//         />
//         <CardContent>
//           <Grid container spacing={3}>
//             {/* Status Filter */}
//             <Grid item xs={12} md={3}>
//               <FormControl fullWidth>
//                 <InputLabel>Status</InputLabel>
//                 <Select
//                   value={filters.status_id}
//                   onChange={(e) => onFilterChange('status_id', e.target.value)}
//                   label="Status"
//                 >
//                   <MenuItem value="">All Statuses</MenuItem>
//                   {statusOptions.map((status) => (
//                     <MenuItem key={status.id} value={status.id}>
//                       {status.name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Assignee Filter */}
//             <Grid item xs={12} md={3}>
//               <FormControl fullWidth>
//                 <InputLabel>Assignee</InputLabel>
//                 <Select
//                   value={filters.assignee_id}
//                   onChange={(e) => onFilterChange('assignee_id', e.target.value)}
//                   label="Assignee"
//                 >
//                   <MenuItem value="">All Assignees</MenuItem>
//                   {usersList.map((user) => (
//                     <MenuItem key={user.id} value={user.id}>
//                       {user.name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Author Filter */}
//             <Grid item xs={12} md={3}>
//               <FormControl fullWidth>
//                 <InputLabel>Created By</InputLabel>
//                 <Select
//                   value={filters.author_id}
//                   onChange={(e) => onFilterChange('author_id', e.target.value)}
//                   label="Created By"
//                 >
//                   <MenuItem value="">All Authors</MenuItem>
//                   {usersList.map((user) => (
//                     <MenuItem key={user.id} value={user.id}>
//                       {user.name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* No Activity Filter */}
//             <Grid item xs={12} md={3}>
//               <TextField
//                 fullWidth
//                 label="No Activity Since (Days)"
//                 type="number"
//                 value={noActivity.no_activity_since_days}
//                 onChange={(e) => onNoActivityChange(e.target.value)}
//                 InputProps={{
//                   inputProps: { min: 1 }
//                 }}
//               />
//             </Grid>

//             {/* Sort Options */}
//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Sort By</InputLabel>
//                 <Select
//                   value={sort.sort_by}
//                   onChange={(e) => onSortChange({ ...sort, sort_by: e.target.value })}
//                   label="Sort By"
//                 >
//                   <MenuItem value="updated_at">Last Updated</MenuItem>
//                   <MenuItem value="created_at">Created AT</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <FormControl fullWidth>
//                 <InputLabel>Sort Direction</InputLabel>
//                 <Select
//                   value={sort.sort_direction}
//                   onChange={(e) => onSortChange({ ...sort, sort_direction: e.target.value })}
//                   label="Sort Direction"
//                 >
//                   <MenuItem value="desc">Descending</MenuItem>
//                   <MenuItem value="asc">Ascending</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </Card>
//     </Collapse>
//   );
// };

// export default LeadFilters;

import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  FormControl,
  InputLabel,
  TextField,
  Button,
  Collapse,
  Autocomplete,
  Select,
  MenuItem
} from '@mui/material';


const LeadFilters = ({
  showFilters,
  filters,
  sort,
  noActivity,
  statusOptions,
  usersList,
  onFilterChange,
  onSortChange,
  onNoActivityChange,
  onClearFilters,
}) => {
  return (
    <Collapse in={showFilters}>
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title="Filters & Sorting"
          action={
            <Button onClick={onClearFilters} color="primary">
              Clear All
            </Button>
          }
        />
        <CardContent>
          <Grid container spacing={3}>
            {/* Status Filter */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  value={filters.status_id}
                  onChange={(e) => onFilterChange('status_id', e.target.value)}
                  label="Status"
                >
                  <MenuItem value="">All Statuses</MenuItem>
                  {statusOptions.map((status) => (
                    <MenuItem key={status.id} value={status.id}>
                      {status.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Assignee Filter with Autocomplete */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <Autocomplete
                  value={filters.assignee_id ? usersList.find(user => user.id === filters.assignee_id) : null}
                  onChange={(e, value) => onFilterChange('assignee_id', value ? value.id : '')}
                  options={usersList}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} label="Assignee" />}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  disableClearable
                  noOptionsText="No assignee found"
                />
              </FormControl>
            </Grid>

            {/* Created By Filter with Autocomplete */}
            <Grid item xs={12} md={3}>
              <FormControl fullWidth>
                <Autocomplete
                  value={filters.author_id ? usersList.find(user => user.id === filters.author_id) : null}
                  onChange={(e, value) => onFilterChange('author_id', value ? value.id : '')}
                  options={usersList}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} label="Created By" />}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  disableClearable
                  noOptionsText="No author found"
                />
              </FormControl>
            </Grid>

            {/* No Activity Filter */}
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="No Activity Since (Days)"
                type="number"
                value={noActivity.no_activity_since_days}
                onChange={(e) => onNoActivityChange(e.target.value)}
                InputProps={{
                  inputProps: { min: 1 },
                }}
              />
            </Grid>

            {/* Sort Options */}
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Sort By</InputLabel>
                <Select
                  value={sort.sort_by}
                  onChange={(e) => onSortChange({ ...sort, sort_by: e.target.value })}
                  label="Sort By"
                >
                  <MenuItem value="updated_at">Last Updated</MenuItem>
                  <MenuItem value="created_at">Created AT</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Sort Direction</InputLabel>
                <Select
                  value={sort.sort_direction}
                  onChange={(e) => onSortChange({ ...sort, sort_direction: e.target.value })}
                  label="Sort Direction"
                >
                  <MenuItem value="desc">Descending</MenuItem>
                  <MenuItem value="asc">Ascending</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Collapse>
  );
};

export default LeadFilters;
